import { Avatar, ChatBubble } from '@amzn/awsui-chat-components';
import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';

export const WelcomeBubble: React.FC<{ onQuestionClick: (question: string) => void }> = ({ onQuestionClick }) => {
  const { t } = useTranslation();

  const sampleQuestions = useMemo(
    () => [
      t(i18nKeys.conversationalAI.welcome.questions.challengeHelp),
      t(i18nKeys.conversationalAI.welcome.questions.teamStatus),
      t(i18nKeys.conversationalAI.welcome.questions.openConsole),
    ],
    [t]
  );

  const questions = useMemo(
    () =>
      sampleQuestions.map((q, i) => (
        <Button variant="inline-link" key={`welcome-q-${i}`} onClick={() => onQuestionClick(q)}>
          {q}
        </Button>
      )),
    [sampleQuestions, onQuestionClick]
  );

  return (
    <ChatBubble
      avatar={
        <Avatar
          ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.assistant)}
          iconName="gen-ai"
          color="gen-ai"
          imgUrl="/assets/monkey-in-circle.png"
        />
      }
      type="incoming"
      ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.welcomeMessage)}
    >
      <Box variant="p" margin={{ bottom: 'm' }}>
        {t(i18nKeys.conversationalAI.welcome.greeting)}
      </Box>
      <SpaceBetween direction="horizontal" size="l">
        {questions}
      </SpaceBetween>
    </ChatBubble>
  );
};

export default WelcomeBubble;
